import RelatedItems from './RelatedItems';

export default RelatedItems;
